import { getDealCardProps } from './dealBenefit';

export const DEAL_TEMPLATES = [
  { id: '2fuer1', label: '2für1', color: '#26a69a' },
  { id: 'gratis', label: 'Gratis', color: '#555555' },
  { id: 'rabatt5', label: '5€ Rabatt', color: '#2196F3' },
  { id: 'rabatt10', label: '10€ Rabatt', color: '#2196F3' },
];

export const CATEGORY_MAX_LENGTH = 12;
export const DEFAULT_BADGE_COLOR = '#26a69a';
export const BADGE_FONT_SIZE = 12;

export function findTemplateByCategory(category, templates = DEAL_TEMPLATES) {
  if (!category) return null;
  const normalized = category.trim().toLowerCase();
  return templates.find(
    (t) => t.label.toLowerCase() === normalized
      || t.id === normalized,
  ) || null;
}

export function getBadgeColor(category, categoryColor, templates = DEAL_TEMPLATES) {
  if (categoryColor) return categoryColor;
  return findTemplateByCategory(category, templates)?.color || DEFAULT_BADGE_COLOR;
}

export function getSpecialBadgeProps(special) {
  const card = getDealCardProps(special || {});
  return {
    badgeText: card.badgeText,
    badgeAlternateText: card.badgeAlternateText,
    badgeAlternateColor: card.badgeAlternateColor,
    badgeAlternateBackgroundColor: card.badgeAlternateBackgroundColor,
    badgeColor: card.badgeColor,
    badgeTextColor: card.badgeTextColor,
    extraTags: card.extraTags,
    oldPrice: card.oldPrice,
    newPrice: card.newPrice,
    discount: card.discount,
    isFree: card.isFree,
    conditionText: card.conditionText,
    mbwDisclaimerText: card.mbwDisclaimerText,
  };
}
